// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__oQbfr","savePackageButton":"ClientWallet_savePackageButton__2NejL"};